import { ButtonPrimary } from "components/Atoms/Button";
import { GroundHeader } from "components/PurpleHeader/GroundHeader";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { DetailSidePanel } from "../DetailSidePanel";
import { GroundSidePanelDetails } from "./GroundSidePanelDetails";
import { useOpenSidePanel } from "../SidePanel";
import { RightClickMenu } from "components/RightClickMenu/RightClickMenuContext";
import { rightMenuForSidePanel } from "components/RightClickMenu/rightClickMenuUtils";
import { invalidateGroundTransportsCache } from "utilities/api/groundTransportQuery";
import { useQueryClient } from "@tanstack/react-query";

export interface GroundTransportSidePanelProps {
  groundTransportId: number
  trigger: JSX.Element
}

export const GroundTransportSidePanel = (props: GroundTransportSidePanelProps) => {
  const queryClient = useQueryClient();

  return <DetailSidePanel
    detailUrl={routes.groundTransport_Detail(props.groundTransportId).absolute}
    apiCall={() => window.CoreApi.GroundTransport.GetSidePanelData(props.groundTransportId)}
    apiKey="groundTransport"
    entityId={props.groundTransportId}
    title={RESX.GroundTransport.resxGroundTransport}
    headerContent={data => <GroundHeader groundTransport={data.groundTransport} passengers={data.passengers} />}
    footerContent={<>
      <ButtonPrimary href={routes.groundTransport_Detail(props.groundTransportId).absolute} label={RESX.Buttons.DetailView} />
    </>}
    trigger={<RightClickMenu
      menuItems={rightMenuForSidePanel(routes.groundTransport_Detail(props.groundTransportId).absolute, {
        duplicate: {
          canDuplicate: site.permissions.groundTransport.canCreate,
          duplicateFn: async () => {
            const resp = await window.CoreApi.GroundTransport.Copy({ groundTransportId: props.groundTransportId });
            return resp.data;
          },
          sidePanelToOpen: "groundTransport",
          invalidateCache: () => invalidateGroundTransportsCache(queryClient),
        },
      })}
    >
      {props.trigger}
    </RightClickMenu>}
  >
    {(data, refetch) => <GroundSidePanelDetails
      groundTransportSidePanelData={data}
      refetch={refetch}
    />}
  </DetailSidePanel>;
};

export const useOpenGroundTransportSidePanel = () => {
  const openSidePanel = useOpenSidePanel();

  const openGroundTransportSidePanel = React.useCallback((groundTransportId: number) => {
    openSidePanel(<DetailSidePanel
      apiCall={() => window.CoreApi.GroundTransport.GetSidePanelData(groundTransportId)}
      apiKey="groundTransport"
      entityId={groundTransportId}
      title={RESX.GroundTransport.resxGroundTransport}
      headerContent={data => <GroundHeader groundTransport={data.groundTransport} passengers={data.passengers} />}
      footerContent={<>
        <ButtonPrimary href={routes.groundTransport_Detail(groundTransportId).absolute} label={RESX.Buttons.DetailView} />
      </>}
      skipSidePanelBase
    >
      {(data, refetch) => <GroundSidePanelDetails
        groundTransportSidePanelData={data}
        refetch={refetch}
      />}
    </DetailSidePanel>, `groundTransport-side-${groundTransportId}`);

  }, [openSidePanel]);

  return openGroundTransportSidePanel;
}
